import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import TeachrRepository from "../../Repositories/TeachrRepository";
import validateEmail from "../../Validation/Email";
import { validatePhoneNumber } from "../../Validation/Phone";
import ClientRepository from "../../Repositories/ClientRepository";
import TeachrContact from "../../Objects/models/TeachrContact";
import { removeExtraSpace } from "../../Utils/Function";
import TeachrContactRepository from "../../Repositories/TeachrContactRepository";
import Functions from "../../Helpers/Functions";
import CustomFees from "../../Objects/models/CustomFees";
import CustomFeesRepository from "../../Repositories/CustomFeesRepository";
import { AddStudentDialogProps, DataDilogLayout } from '../../Objects/interfaces/AppInterface';
import DialogLayout from '../../Components/DialogLayout';
import DialogSlide from '../../Components/DialogSlide';
import FormSlide from '../../Components/FormSlide';
import { getAllClients } from '../../Redux/Actions/StudentActions';
import { AppDispatch } from '../../Redux/store';
import { SHOW_INFO_AUTH } from '../../Redux/Reducers/MessageReducers';
import { ENV_DECLARONS, ENV_TEACHR, getActiveAppBrandConfig, getActiveClientBrandConfig, getUriAppBrandConfig, isBrandActive } from '../../config/environment.config';


const AddStudentDialog: React.FC<AddStudentDialogProps> = ({
  openView,
  setOpenView,
  teachr,
  params,
}) => {
  
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const teachrCode = teachr?.invitationCode;
  const [link, setLink] = useState<string>("");
  const [isCopy, setIsCopy] = useState(false);
  const [showDialog2, setShowDialog2] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errors, setErrors] = useState({
    mail: false,
    telephone: false,
  });

  const handleClose = () => {
    setEmail("");
    setPhone("");
    setLastName("");
    setFirstName("");
    if (showDialog) {
      setShowDialog(false);
      setOpenView(false);
    } else if (showDialog2) {
      setShowDialog2(false);
      setOpenView(false);
    } else {
      setOpenView(false);
    }
  };

  const validation = (): boolean => {
    let valid = {
      mail: false,
      telephone: false,
    };

    valid.mail = !validateEmail(email).isValid;
    if (validatePhoneNumber(phone) === "") {
      valid.telephone = false;
    } else {
      valid.telephone = true;
    }

    setErrors(valid);
    if (!valid.mail && !valid.telephone) {
      return true;
    } else {
      return false;
    }
  };
  const sendTeachrCode = async () => {
    if (!teachr?.id) return;

    try {
      await ClientRepository.sendTeachrCode(email, teachr.id);
      handleClose();
      dispatch({
        type: "SHOW_SUCCESS",
        payload:
          "Votre client vient de recevoir un mail contenant votre code de parrainage.",
      });
    } catch (error) {
      console.error(
        "Failed to send teachr code:",
        JSON.parse(JSON.stringify(error))
      );
      dispatch({
        type: "SHOW_ERROR",
        payload:
          "Une erreur est survenue lors de l'envoi du code de parrainage.",
      });
    }
  };

  const createAccount = async (teachrContact: TeachrContact) => {
    try {
      const response = await TeachrContactRepository.createTeachrContact(
        teachrContact
      );
      const baseUrl = `${getUriAppBrandConfig()}/client/complete-infos/`;
      setLink(`${baseUrl}${response.key}`);
      setShowDialog2(true);
      if (params) {
        dispatch(getAllClients(params));
      }
    } catch (error) {
      handleCreateTeachrContactErrors(error);
    }
  }
  const handleCreateTeachrContact = async () => {
    const teachrId: any = teachr && teachr["@id"];
    const teachrContact = new TeachrContact(0, removeExtraSpace(email), teachrId);
    teachrContact.phoneNumber = phone || "";
    if (isBrandActive(ENV_DECLARONS)) teachrContact.brand = ENV_DECLARONS
    if (firstName) teachrContact.studentName = firstName;
    if (lastName) teachrContact.name = lastName;
    setLoading(true);
    try {
      // Un e-mail déjà rattaché à un compte client n'est plus bloquant : le
      // backend envoie alors une invitation à activer l'avance immédiate
      // depuis l'espace client (parcours prérempli, mise en relation par clé).
      createAccount(teachrContact)
    } catch (errors) {
      setLoading(false);
      // setLoad(false);
      handleCreateTeachrContactErrors(errors);
    } finally {
      setLoading(false);
      // setLoad(false);
    }
  };
  const handleCreateTeachrContactErrors = (errors: any) => {
    handleClose();
    setLoading(false);
    // setLoad(false);
    switch (errors._description) {
      case "Invalid Authorization header.":
        dispatch({
          type: SHOW_INFO_AUTH,
          payload: "Votre session a expiré, merci de vous reconnecter pour continuer.",
        });
        navigate("/");
        break;
      case "Constraint violation":
        errors._arrayInvalidAttributes?.forEach((error: any) => {
          if (error.fieldName === "mail") {
            dispatch({
              type: "SHOW_WARNING",
              payload:
                "Cet e-mail est déjà rattaché à un compte, merci de le changer pour continuer.",
            });
          }
        });
        break;
      default:
        dispatch({
          type: "SHOW_ERROR",
          payload:
            `Erreur inattendue, merci de nous contacter sur ${process.env.REACT_APP_MAIL_SUPPORT}`,
        });
        break;
    }
  };
  const handleAddStudent = async () => {
    if (!validation()) return;

    setLoading(true);
    // setLoad(true);
    if (!teachr?.id) return;

    try {
      const client: any = await TeachrRepository.addFavoriteTeachr(
        teachr.id,
        email,
        Functions.formatPhoneNumber(phone)
      );
      if (client["@id"] && teachr["@id"]) {
        const customFees = new CustomFees(
          [client["@id"]],
          [teachr["@id"]],
          null,
          null,
          !client.isRelationTeachr
        );
        try {
          const custom = await CustomFeesRepository.createCustomFees(customFees);
          if (custom) {
            handleClose();
            if (params) dispatch(getAllClients(params));
            dispatch({
              type: "SHOW_SUCCESS",
              payload:
                `Le client que vous venez d'ajouter possède déjà un compte chez ${getActiveAppBrandConfig()}, et l'ajout a été effectué avec succès. S'il n'a pas encore activé son avance immédiate, il pourra le faire depuis son espace client (Paramètres puis Avance immédiate).`,
            });
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        if (client.statut === "no client" || client.statut === "no client scoop") {
          handleCreateTeachrContact();
        }
      }
    } catch (err) {
      handleAddStudentErrors(err);
    } finally {
      setLoading(false);
      // setLoad(false);
    }
  };
  const handleAddStudentErrors = (err: any) => {
    switch (err._description) {
      case "Client don't have idTiersPrestation":
        setShowDialog(true);
        break;
      case "you are already register this client":
        handleClose();
        dispatch({
          type: "SHOW_WARNING",
          payload:
            `Le client est déjà enregistré et fait partie de vos clients. Veuillez vérifier dans "Mes ${isBrandActive(ENV_TEACHR) ? 'élèves' : 'clients'} inscrits".`,
        });
        break;
      case "ERR_RECHERCHE_PARTICULIER":
        handleClose();
        dispatch({
          type: "SHOW_ERROR",
          payload:
            `Aucun particulier correspondant aux critères
            renseignés a une inscription active avec le ${getActiveAppBrandConfig()}.
            Cela peut correspondre à un particulier ayant rompu
            son association avec le prestataire`,
        });
        break;
      default:
        handleClose();
        dispatch({
          type: "SHOW_ERROR",
          payload: "Erreur inconnue",
        });
        break;
    }
  };
  const displayBody = () => (
    <Swiper
      className="h-full"
      slidesPerView={1}
      speed={700}
      navigation={{ nextEl: ".next-slide", prevEl: ".prev-slide" }}
      modules={[Navigation]}
      effect="slide"
      allowTouchMove={false}
    >
      {showDialog ? (
        <SwiperSlide>
          <DialogSlide
            message={`${getActiveClientBrandConfig('', "L'", "Le ")} que vous essayez d'ajouter posséde déjà un compte sur ${getActiveAppBrandConfig()}. Pour qu'il puisse tirer parti de l'avance de crédit d'impôt immédiatement, veuillez lui communiquer le code ci-dessous afin qu'il puisse activer cette option depuis son espace ${getActiveAppBrandConfig()}. Si vous préférez, vous pouvez également choisir de lui envoyer un email`}
            linkText="cliquez ici."
            onLinkClick={sendTeachrCode}
            code={teachrCode || ""}
            onClose={handleClose}
            isCopy={isCopy}
            onCopy={() => setIsCopy(true)}
          />
        </SwiperSlide>
      ) : showDialog2 ? (
        <SwiperSlide>
          <DialogSlide
            message={`Votre questionnaire a bien été envoyé à votre client. Une fois validé, le statut de votre ${getActiveClientBrandConfig()}  changera directement sur le tableau de bord. Un lien exclusif a été créé pour votre ${getActiveClientBrandConfig()} . Si cela vous convient, vous pouvez le copier et le partager avec lui.`}
            code={link || ""}
            onClose={handleClose}
            isCopy={isCopy}
            onCopy={() => setIsCopy(true)}
          />
        </SwiperSlide>
      ) : (
        <>
          <SwiperSlide>
            <FormSlide
              email={email}
              setEmail={setEmail}
              phone={phone}
              setPhone={setPhone}
              errors={errors}
              firstName={firstName}
              setFirstName={setFirstName}
              lastName={lastName}
              setLastName={setLastName}
              // onClose={handleClose}
              onSubmit={handleAddStudent}
              loading={loading}
            // childsEmpty={childs?.length === 0}
            // navigateToSetup={() => navigate(`/${getActiveAppBrandConfig()}/tableau-de-bord/setup`)}
            />
          </SwiperSlide>
        </>
      )}
    </Swiper>
  );
  const dataDiologInfo: DataDilogLayout = {
    title: `${showDialog2 ? "Félicitations 🥳 " : `Ajout d’un ${getActiveClientBrandConfig()} ✏️`}`,
    text: displayBody(),
    open: openView,
    load: loading,
    customDialogActions: "hidden",
    handleCloseIcon: handleClose,
  };

  return (
    <DialogLayout
      title={dataDiologInfo.title}
      text={dataDiologInfo.text}
      open={dataDiologInfo.open}
      customDialogActions={dataDiologInfo.customDialogActions}
      btnChildren=""
      handleCloseIcon={dataDiologInfo.handleCloseIcon}
    />
  );
};

export default AddStudentDialog;
